import PropTypes from 'prop-types';
import React from 'react';
import FieldHelperText from '~components/field-helper-text';
import RangeDayPickerInput from './range-day-picker-input';

const FormControlRangeDayPickerInput = React.forwardRef((props, ref) => {
  const {
    style,
    className,
    error,
    placeholder,
    placement,
    FieldHelperTextProps,
    InputProps,
    TooltipProps,
    ...otherProps
  } = props;
  return (
    <div style={style} className={className} ref={ref}>
      <RangeDayPickerInput
        TooltipProps={{ placement, ...TooltipProps }}
        InputProps={{ error: !!error, placeholder, ...InputProps }}
        {...otherProps}
      />
      <FieldHelperText {...FieldHelperTextProps}>{error}</FieldHelperText>
    </div>
  );
});

FormControlRangeDayPickerInput.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  placement: PropTypes.oneOf([
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top',
  ]),
  FieldHelperTextProps: PropTypes.object,
  // props applied to Input
  InputProps: PropTypes.object,
  // props applied to Tooltip
  TooltipProps: PropTypes.object,
  // otherProps will be applied to RangeDayPickerInput
};

FormControlRangeDayPickerInput.defaultProps = {
  style: {},
  className: undefined,
  error: undefined,
  placeholder: undefined,
  placement: 'bottom-start',
  FieldHelperTextProps: {},
  InputProps: {},
  TooltipProps: {},
};

export default FormControlRangeDayPickerInput;
